/**
 * Story text (GDD: Story and world). Memory logs drop from beaten rogue suits; the Ranger's is the
 * free tier's cliffhanger: Dad is alive. Upper case only (the pixel font has no lower case).
 */

export interface MemoryLog {
  readonly title: string;
  readonly lines: readonly string[];
}

/**
 * What the suit says in the lab. Each rewind costs it a memory and gives back another, so there is
 * a new line after every rewind (GDD: How story keeps moving). Whether the suit's mind is Dad's
 * is still open in the GDD; these lines leave it open.
 */
export const SUIT_LINES: readonly string[] = [
  'YOU FOUND ME. STEP IN, KIDDO. WE HAVE A LONG WAY TO GO.',
  'WE CAME BACK. I CAME BACK. SOMETHING IS MISSING NOW.',
  'I REMEMBER A KITCHEN. PANCAKES. WHOSE KITCHEN WAS IT?',
  'GALACTIV SENT TEN OF US. I CAN STILL HEAR THE OTHERS, FAR OFF.',
  "THE RANGER WAS A FRIEND, ONCE. DON'T LET THAT SLOW YOUR HAND.",
  'EVERY TIME WE REWIND, I TRADE A MEMORY FOR THE WAY BACK.',
  "THE STARS GET LOUDER WHEN WE'RE HUNGRY. DON'T LISTEN TOO CLOSELY.",
];

/** After the Ranger's log: the signal on the ocean world is the rest of the suit's mind. */
export const SUIT_LINE_AFTER_LOG =
  "THAT SIGNAL ON THE OCEAN WORLD. IT'S MINE. THE REST OF ME. WE'RE GOING TO GET IT BACK.";

/** The suit's line for this visit to the lab. */
export function suitLine(rewinds: number, seenLog: boolean): string {
  if (seenLog && rewinds % 3 === 0) return SUIT_LINE_AFTER_LOG;
  return SUIT_LINES[Math.min(rewinds, SUIT_LINES.length - 1)] ?? '';
}

export const RANGER_LOG: MemoryLog = {
  title: 'MEMORY LOG: RANGER',
  lines: [
    'THE SUIT WAS HUNGRY. I FED IT A STAR.',
    'THEN ANOTHER. THEN I STOPPED COUNTING.',
    'THE CAPTORS KEEP ONE OF US ALIVE,',
    'ON THE OCEAN WORLD. HE STILL SIGNALS.',
    'YOUR SUIT KNOWS HIS VOICE.',
  ],
};
